import vueComponentOptions from 'components/InputDateTimePicker.vue';

const DateTimePickerInput = Vue.extend(vueComponentOptions);

module.exports = DateTimePickerInput;
